import { render } from "./Pantries.vue?vue&type=template&id=4595b8c2"
import script from "./Pantries.vue?vue&type=script&lang=js"
export * from "./Pantries.vue?vue&type=script&lang=js"
script.render = render

export default script